import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'portfolio-3-onboarding.onboarding.spotlight-scope.title',
		defaultMessage: "What's in a plan?",
		description: 'The title for the spotlight',
	},
	content: {
		id: 'portfolio-3-onboarding.onboarding.spotlight-scope.content',
		defaultMessage:
			'At its core, your plan consists of issues from your projects which show in the Scope column.',
		description: 'The content for the spotlight.',
	},
});
